export default __webpack_public_path__ + "static/mesh-manager-a0f44f22d3ab0eaa7d52db7676d4303e.webp";